import React from "react";
import "./loading.scss";

const Loading = () => {
  return (
    <div className="loading">
      <div></div>
    </div>
  );
};

export default Loading;
